module.exports = __webpack_public_path__ + "static/media/3-4.f969bba8.mp3";